import { displayToast } from '../../../../helpers/notification';
import { AdminSettingTypes as Type } from '../../../types/adminsetting';


export function addNewAdminRequest(body: any) {
  return {
    type: Type.ADD_NEW_ADMIN_REQUEST,
    body: body,
  };
}

export function addNewAdminRequestSuccess(data: any) {
  return {
    type: Type.ADD_NEW_ADMIN_REQUEST_SUCCESS,
    payload: data,
  };
}

export function addNewAdminRequestFailure(error: any) {
  try {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.length > 0
    ) {
      if (Array.isArray(error.response.data.message))
        displayToast('ERROR', error.response.data.message[0]);
      else displayToast('ERROR', error.response.data.message);
    } else {
      displayToast('ERROR', error.message);
    }
  } catch (e) {
    displayToast('ERROR', error.message);
  }
  return {
    type: Type.ADD_NEW_ADMIN_REQUEST_FAILURE,
    error: error,
  };
}

export function resetStateAddAdmin() {
  return {
    type: Type.RESET_ADD_ADMIN_STATE,
  };
}
